import { Box } from '@mui/material';
import { CurrencyInput, DateInput, MultiSelectInput, NPSRatingInput, NumberInput, RadioInput, SelectInput, StarsRatingInput, TextareaInput, TextInput, TitleText, UploadInput } from './Questions';
import { useAuth } from '../../hooks/useAuth';

function GeneralScreen({
    isLock = false,
    currentStep = 0,
    questionsList = [],
    questionsListToValidate = [],
    handleDataChange = () => {},
    shouldQuestionOrScreenVisible = () => {},
    handleReset = () => {},
    handleSetVisibility = () => {},
    contactId,
}) {
    const { getUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const questionListOnConditions = questionsList.filter((cQuestion) => {
        const shouldVisible = shouldQuestionOrScreenVisible({
            conditionalRequirement: cQuestion?.Condition_Requirement__c,
            conditionalLogic: cQuestion?.Condition_Logic__c,
            conditionList: cQuestion?.Conditions2__r?.records,
            questionList: questionsListToValidate,
        });
        if (shouldVisible) {
            handleSetVisibility(true, cQuestion.Id, currentStep);
            return true;
        }
        handleSetVisibility(false, cQuestion.Id, currentStep);
        return false;
    });

    return (
        <Box
            sx={{
                width: {
                    xs: '100%',
                    md: '700px',
                },
                maxWidth: {
                    xs: '100%',
                    md: '700px',
                },

                marginTop: '1rem',

                '&>*:not(:last-child)': {
                    marginBottom: '2.5rem',

                    '&.titleText': {
                        marginBottom: '1.5rem',
                    },
                },
            }}
        >
            {questionListOnConditions.map((cQuestion, index) => {
                if (cQuestion.Type__c === 'Picklist') {
                    return <SelectInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'Radio') {
                    return <RadioInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'Text') {
                    return <TextInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'CSAT') {
                    return <StarsRatingInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'NPS') {
                    return <NPSRatingInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'Date') {
                    return <DateInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'Number') {
                    return <NumberInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'Currency') {
                    return <CurrencyInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'Multi-select') {
                    return <MultiSelectInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'File') {
                    return (
                        <UploadInput
                            parentId={cQuestion.Id + '-' + (contactId ? contactId : userDetails.contact.id)}
                            disabled={isLock}
                            key={cQuestion.Id}
                            questionNumber={index + 1}
                            question={cQuestion}
                            screenNo={currentStep}
                            handleDataChange={handleDataChange}
                            displayItemSizes={{
                                xs: 12,
                                md: 12,
                                lg: 6,
                                xl: 6,
                            }}
                        />
                    );
                }
                if (cQuestion.Type__c === 'Textarea') {
                    return <TextareaInput disabled={isLock} key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={currentStep} handleDataChange={handleDataChange} />;
                }
                if (cQuestion.Type__c === 'Display Text') {
                    return <TitleText key={cQuestion.Id} question={cQuestion} />;
                }
                return <></>;
            })}
        </Box>
    );
}

export default GeneralScreen;
